export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 2h8a1 1 0 011 1v8a1 1 0 01-1 1H7a1 1 0 01-1-1V3a1 1 0 011-1zM4 3a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-1v1a3 3 0 01-3 3H3a3 3 0 01-3-3V7a3 3 0 013-3h1V3zm0 3H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1v-1H7a3 3 0 01-3-3V6z\" fill=\"#005AD9\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};